import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import { getAllRoutes } from "routes/navigation.config";

export default function AppRoutes() {
  const routes = getAllRoutes();

  return (
    <Routes>
      {routes.map(({ path, Component, isPrivate }) => (
        <Route
          key={path}
          element={
            isPrivate ? (
              <PrivateRoute component={<Component />} />
            ) : (
              <Component />
            )
          }
          path={path}
        />
      ))}
      <Route path="*" element={<Navigate to="/transaction-history" />} />
    </Routes>
  );
}
